import * as PSService from '@/services/ps.service';

export default {
    namespaced: true,
    state: () => ({
        list: {
            initialized: false,
            values: []
        }
    }),
    actions: {
        async load({ commit, state }) {
            if (state.list.initialized) {
                return Promise.resolve(state.list);
            }
            try {
                const res = await PSService.getAll();
                commit('LOAD_PS', res.data);
                return await Promise.resolve(res.data);
            } catch (e) {
                return await Promise.reject();
            }
        },
        async loadPublico({ commit }) {
            try {
                const res = await PSService.getAllPublico();
                commit('LOAD_PS', res.data);
                return await Promise.resolve(res.data);
            } catch (e) {
                return await Promise.reject();
            }
        },
        async create({ commit }, processoSeletivo) {
            const res = await PSService.create(processoSeletivo);
            commit('ADD_PS', res.data);
            return await Promise.resolve(res.data);
        },
    },
    mutations: {
        LOAD_PS(state, data) {
            state['list']['initialized'] = true;
            state['list']['values'] = data;
        },
        ADD_PS(state, processoSeletivo) {
            state['list']['values'].push(processoSeletivo);
        },
    },
    getters: {
        list: state => {
            return state.list.values;
        }
    }
}